import { LayoutDashboard, NotebookPen, Wallet } from 'lucide-react';
import type { Scope } from '@homejournal/types';

export interface NavItem {
  to: string;
  label: string;
  Icon: React.ComponentType<{ className?: string }>;
  primary?: boolean;
  /** Undefined = always shown (Dashboard). Otherwise the scope required. */
  scope?: Scope;
}

/**
 * Home Journal has exactly three top-level destinations. Order matters —
 * SideNav and BottomNav both consume this list verbatim (post-scope filter).
 */
export const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', Icon: LayoutDashboard, primary: true },
  { to: '/journal', label: 'Journal', Icon: NotebookPen, primary: true, scope: 'journal' },
  { to: '/expenses', label: 'Expenses', Icon: Wallet, primary: true, scope: 'expense' },
];
